import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import NoDataResource from '../../../common/resource/NoDataResource';
import BankAccountBasicInformationResource from './resource/BankAccountBasicInformationResource';
import { BANK_ACCOUNT_PATH } from '../../../../config/paths';
import BankAccountToolbar from './BankAccountToolbar';
import { clearBankAccount, getBankAccount } from '../../../../actions';

export const BankAccount = ({
  breadcrumbs,
  match: {
    params: { id: bankAccountId },
  },
  bankAccount,
  loading,
  dispatchGetBankAccount,
  dispatchClearBankAccount,
}) => {
  useLayoutEffect(() => {
    dispatchGetBankAccount({ bankAccountId });

    return () => dispatchClearBankAccount();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (bankAccount.isEmpty()) {
    content = <NoDataResource returnPage={BANK_ACCOUNT_PATH} />;
  } else {
    const bankAccountJSON = bankAccount.toJS();
    content = <BankAccountBasicInformationResource {...bankAccountJSON} />;
    toolbar = <BankAccountToolbar bankAccountId={bankAccountJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Cuenta Bancaria"
      toolbar={toolbar}
      content={content}
    />
  );
};

BankAccount.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  bankAccount: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetBankAccount: PropTypes.func.isRequired,
  dispatchClearBankAccount: PropTypes.func.isRequired,
};

BankAccount.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cuentas Bancarias',
      href: BANK_ACCOUNT_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  bankAccount: AccountingUnit.BankAccount.getIn(['current', 'content']),
  loading: !AccountingUnit.BankAccount.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetBankAccount: getBankAccount,
  dispatchClearBankAccount: clearBankAccount,
};

export default connect(mapStateToProps, mapDispatchToProps)(BankAccount);
